var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "Etiket ve Renk Özelleştirme",
        width: "500px",
        confirmLoading: _vm.saving,
      },
      on: {
        ok: _vm.handleSave,
        close: _vm.handleClose,
        cancel: _vm.handleClose,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "label-customization" },
        _vm._l(_vm.categoryItems, function (item, key) {
          return _c(
            "div",
            { key: key, staticClass: "label-item" },
            [
              _c("a-input", {
                staticStyle: { width: "200px" },
                attrs: { defaultValue: key },
                model: {
                  value: item.label,
                  callback: function ($$v) {
                    _vm.$set(item, "label", $$v)
                  },
                  expression: "item.label",
                },
              }),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons arrow-icon" }, [
                _vm._v("arrow_forward"),
              ]),
              _vm._v(" "),
              _c("a-input", {
                staticStyle: { width: "50px" },
                attrs: { type: "color" },
                model: {
                  value: item.color,
                  callback: function ($$v) {
                    _vm.$set(item, "color", $$v)
                  },
                  expression: "item.color",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }